var React = require('react');

function CheckIcon (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M0 0h24v24H0z","fill":"none","key":0}),React.createElement("path",{"fill":"#fff","d":"M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z","key":1})]);
}

CheckIcon.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = CheckIcon;

CheckIcon.default = CheckIcon;
